/** Passerelles Paramètres → Paiements. */

export type GatewayProvider = "gocardless" | "paypal" | "stripe";
export type GatewayStatus = "absent" | "added" | "connected";

export type GatewayRow = {
  provider: GatewayProvider;
  status: GatewayStatus;
  connected: boolean;
};

export const GATEWAY_CATALOG: { id: GatewayProvider; label: string; hint: string }[] = [
  { id: "gocardless", label: "GoCardless", hint: "Prélèvements SEPA" },
  { id: "paypal", label: "PayPal", hint: "PayPal Commerce" },
  { id: "stripe", label: "Stripe", hint: "Carte / SEPA" },
];

export function mergeGateways(rows: GatewayRow[] | undefined): GatewayRow[] {
  const by = new Map((rows || []).map((r) => [r.provider, r]));
  return GATEWAY_CATALOG.map((c) => by.get(c.id) ?? { provider: c.id, status: "absent", connected: false });
}

export function connectedGateways(rows: GatewayRow[] | undefined): Set<GatewayProvider> {
  return new Set(mergeGateways(rows).filter((r) => r.connected).map((r) => r.provider));
}
